// extracted by mini-css-extract-plugin
export var container = "Avatar-module--container--lNE8L";